import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, HttpParams, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MomentModule } from 'ngx-moment';
import { SharedModule } from '@shared/shared.module';
import { RequestInterceptor } from './core/interceptors/request.interceptor';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { AppComponent } from './app.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PageNotFoundComponent } from './core/errorpages/page-not-found/page-not-found.component';
import { UnauthorizedComponent } from './core/errorpages/unauthorized/unauthorized.component';
import { QuillModule } from 'ngx-quill';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomeModule } from '@modules/home/home.module';
import { environment } from '@environments/environment';
import { CustomLoader } from '@shared/utilities/custom-loader';
import { LinkExpireComponent } from './core/errorpages/link-expire/link-expire.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';   // GAHR-1468
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from '@gah-core/Router/CustomRouteReuseStrategy';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './material/material.module';
import { MaintenanceComponent } from '@gah-core/errorpages/maintenance/maintenance.component';
import { MatIconModule } from '@angular/material/icon';

let redirectUri;
switch (window.location.hostname) {
  case 'globalassethub-qa.sonypictures.com':
    redirectUri= environment.okta.redirectUri;
    break;
  case 'globalassethub-stg.sonypictures.com':
    redirectUri= environment.okta.redirectUri;
    break;
  case 'globalassethub-dev.sonypictures.com':
    redirectUri= environment.okta.redirectUri;
    break;
  case 'qa.sonypicturespublicity.net':
    redirectUri = environment.oktapublicity.redirectUri;
    break;
  case 'globalassethub.sonypictures.com':
    redirectUri = environment.okta.redirectUri;
    break;
  case 'www.sonypicturespublicity.net':
    redirectUri = environment.oktapublicity.redirectUri;
    break;
  case 'www.sonypicturespublicity.com.au':
    redirectUri = environment.oktapublicityaus.redirectUri;
    break;
  case 'www.sonypicturespublicity.com':
    redirectUri = environment.oktapublicitydotcom.redirectUri;
    break;
  case 'www.sonypicturespresse.fr':
    redirectUri = environment.oktapublicityfr.redirectUri;
    break;
  case 'www.sonypicturespublicity.co.nz':
    redirectUri = environment.oktapublicitynz.redirectUri;
    break;
  case 'sonypicturespublicity.com':
      redirectUri = environment.oktapublicity1.redirectUri;
      break;
  default:
    redirectUri = environment.okta.redirectUri;
}

//GAHR1553
const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: redirectUri
});
@NgModule({ declarations: [AppComponent, PageNotFoundComponent, UnauthorizedComponent, LinkExpireComponent, MaintenanceComponent],
    bootstrap: [AppComponent], imports: [NgxSpinnerModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgScrollbarModule,
        NgxSpinnerModule,
        SharedModule,
        HomeModule,
        DragDropModule,
        QuillModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomLoader,
                deps: [HttpClient],
            },
        }),
        NgIdleKeepaliveModule.forRoot(),
        MatIconModule,
        MaterialModule,
        TextFieldModule,
        MomentModule.forRoot({
            relativeTimeThresholdOptions: {
                m: 59,
            },
        }),
        LoggerModule.forRoot({
            level: NgxLoggerLevel.DEBUG,
            enableSourceMaps: true,
            colorScheme: ['purple', 'teal', 'teal', 'lightblue', 'orange', 'red', 'red'],
        }),
        RecaptchaModule,
        RecaptchaFormsModule,
        OktaAuthModule.forRoot({ oktaAuth }) //GAHR1553
    ], providers: [
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true,
        },
        {
            provide: Window,
            useValue: window,
        },
        { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}